import  { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseUser } from '../contexts/SupabaseUserContext';

const ProtectedRoute = ({ children }) => {
  const supabaseUser = useSupabaseUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (supabaseUser) {
      navigate('/');
    }
  }, [supabaseUser, navigate]);

  return !supabaseUser ? children : null;
};

export default ProtectedRoute;